<template>
  <span :class="bemClass()"
  >
    <slot/>
    <span :class="bemClass('value')" v-if="value > 0">
      {{ value }}
    </span>
  </span>
</template>

<script>
import useBem from '../../compositions/bem'
import { toRefs } from 'vue'

export default {
  name: 'SelBadge',
  props: {
    value: {
      type: Number,
      default: 0
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const { modifier } = toRefs(props)
    const { bemClass } = useBem('sel-badge', modifier)

    return {
      bemClass
    }
  }
}
</script>

<style scoped>
.sel-badge {
  position: relative;
  display: inline-block;
}

.sel-badge__value {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(50%, -50%);
  background: #ff0000;
  color: #ffffff;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  font-size: 10px;
  text-align: center;
  line-height: 20px;
}
</style>
